module.exports = __webpack_public_path__ + "img/S.1db749bc.svg";